import { Building2, Users, HardHat, Layers, Award, Truck, ShieldCheck, Star } from "lucide-react";

export const STAT_ICONS = {
  building: Building2,
  users: Users,
  hardhat: HardHat,
  layers: Layers,
  award: Award,
  truck: Truck,
  shield: ShieldCheck,
  star: Star,
};
